
snt-province-modal-selector {

    @media(min-width:768px ){
        ul{
            max-height: 170px !important;
        } 
    }
    .provinceModalHeader{
        margin-bottom: 10px !important;

        @media(min-width:1024px){
            margin-bottom: 15px!important;
        }
    }
    .provinceModalNotes{
        margin-bottom: 30px!important;
    }
    snt-form label{
        font-size: 14px;
        
        @media (min-width:1024px) {
            font-size: 16px;
        }
    }
    .dropdownContainer{
        margin-bottom: 26px !important;
        @media(min-width:1024px){
            margin-bottom: 30px!important;
        }
    }

}
    

